import api from './api';

/**
 * El catálogo del contador visto desde el ENLACE: el contador del cliente contesta sin cuenta.
 *
 * Tiene los mismos nombres que los métodos del catálogo en `cd2bPropuestaService` para que la
 * pantalla sea UNA sola: recibe este servicio y le pasa el token donde el asesor pasa el id.
 */
const base = (token) => `/cd2b/catalogo-contador-publico/${encodeURIComponent(token)}`;

const cd2bCatalogoContadorPublicoService = {
  async estadoCatalogoContador(token) {
    const response = await api.get(base(token));
    return response.data;
  },
  async analizarCatalogoContador(token, { archivo, texto }) {
    const fd = new FormData();
    if (archivo) fd.append('archivo', archivo);
    if (texto) fd.append('texto', texto);
    const response = await api.post(`${base(token)}/analizar`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
  async conciliarCatalogoContador(token, { decisiones, confirmaciones } = {}) {
    const response = await api.post(`${base(token)}/conciliar`, {
      ...(decisiones ? { decisiones } : {}),
      ...(confirmaciones ? { confirmaciones } : {}),
    });
    return response.data;
  },
  /** El contador firma; si hay catálogo propio lo decidió ya el asesor, así que `propio` no viaja. */
  async declararCatalogoContador(token, { contador } = {}) {
    const response = await api.put(`${base(token)}/declaracion`, { contador });
    return response.data;
  },
};

export default cd2bCatalogoContadorPublicoService;
